export const OptInsPatchCheckMapper = {
  hydrate(data) {
    return {
      op: "processPatchCheckOptinConditions",
      ...data,
    };
  },
};

export const OptInsPatchSyncLenderMapper = {
  hydrate(data) {
    return {
      op: "processPatchSyncLenderOptIns",
      ...data,
    };
  },
};
